import { getStore } from '../store/Store';
import BrowserWidthBucket from '../store/schema/BrowserWidthBucket';

/**
 * Returns a flag indicating whether to show folder pane as an overlay or not
 */
export function shouldShowFolderPaneAsOverlay() {
    switch (getStore().browserWidthBucket) {
        case BrowserWidthBucket.From418_Below:
        case BrowserWidthBucket.From419_To554:
        case BrowserWidthBucket.From555_To768:
        case BrowserWidthBucket.From769_To918:
            return true;
        case BrowserWidthBucket.From919_To999:
        case BrowserWidthBucket.From1000_To1199:
        case BrowserWidthBucket.From1200_To1399:
        case BrowserWidthBucket.From1400_To1599:
        case BrowserWidthBucket.From1600_Above:
        default:
            return false;
    }
}
